<style scoped lang="scss">
@import "../scss/variables.scss";
</style>
<template>
  <div class="real-container pl-container">
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="ui-col justify-center"
      >
        <h2 class="content-tit">
          개인정보 보호 정책
        </h2>
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-row"
      >
        <h3 class="sub-tit">
          개인정보처리방침
        </h3>
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="ui-col flex-cloumn text-end"
      >
        <p class="default-txt">
          - 2023년 9월 23일 제정
        </p>
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="ui-col flex-cloumn"
      >
        <p class="default-txt text-block">
          에이엠오아시아리미티드(이하 ‘회사’라 한다)는 개인정보 관계 법령에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립·공개합니다.
        </p>
        <p class="default-txt"><span class="bold">제1조(개인정보의 처리목적)</span> 회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호 관계 법령에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-row"
      >
      <table class="pl-table">
        <colgroup>
          <col style="width:10%">
          <col style="width:10%">
          <col style="width:20%">
          <col style="width:40%">
          <col style="width:20%">
        </colgroup>
        <thead>
          <tr>
            <th scope="col"><strong>분류</strong></th>
            <th scope="col"><strong>필수/ 선택</strong></th>
            <th scope="col"><strong>목적</strong></th>
            <th scope="col"><strong>항목</strong></th>
            <th scope="col"><strong>보유 및 이용기간</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              개인식별정보,<br>제한적 본인 식별정보
            </td>
            <td>
            <p>필수</p>
            </td>
            <td>
              제품설명회의 원활한 진행 및 참석자 확인, 지출보고서 작성 및 보고, 기타 관련 법령 준수의 증빙 목적, 촬영 사진 제공
            </td>
            <td>
              성명, 소속 의료기관명, 진료과, 제공된 경제적 이익의 형태 및 금액, 행사에 참여하고 계신 귀하의 모습을 촬영한 사진, 행사 관련 사항 (행사명, 제품명, 장소, 일시) (행사 진행을 위해 연락이 필요한 경우 및/또는 촬영 사진 제공을 요청하시는 경우에 한하여) 휴대전화번호 및/또는 이메일 주소
            </td>
            <td rowspan="2">
              관계 법령의 규정에 따라 귀하의 개인정보를 보존할 의무가 있는 경우가 아닌 한, 개인정보 수집일이 속한 회계연도 종료 후 10년까지. 다만, 사진 제공을 위한 이메일 주소의 경우 사진 제공 후 파기합니다.
            </td>
          </tr>
          <tr>
            <td>
              대리점, 보건의료인
            </td>
            <td>
              필수
            </td>
            <td>
              제품공급계약
            </td>
            <td>
              사업자등록증상의 정보(상호, 사업자등록번호, 개업년월일, 주소, 업종, 업태), 회사 전화번호, 회사 e-mail주소, 담당직원의 이름/부서/직책/전화번호/e-mail 주소/회사계좌번호/ 주식회사인 경우 주주이름과 소유지분
            </td>
          </tr>
          </tbody>
        </table>
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="ui-col flex-cloumn"
      >
        <p class="default-txt"><span class="bold">제2조(개인정보의 처리 및 보유기간)</span> ① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
        <p class="default-txt">② 각각의 개인정보 처리 및 보유 기간은 제1조에 기재된 바와 같습니다.</p>
        <p class="default-txt"><span class="bold">제3조(개인정보의 제3자 제공)</span> 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. 현재는 제3자에게 제공하는 개인정보가 없습니다.</p>
        <p class="default-txt"><span class="bold">제4조(개인정보처리의 위탁)</span> ① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
        <p class="default-txt"></p>
      </v-col>
      <v-col>
        <table class="pl-table">
          <colgroup>
            <col style="width:30%">
            <col style="width:40%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col"><strong>회사명</strong></th>
              <th scope="col"><strong>위탁업무의 내용</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                용마로지스㈜
              </td>
              <td>
                써지컬 비전 제품 배송 및 반품 서비스
              </td>
            </tr>
            <tr>
              <td>
                DA INFORMATION
              </td>
              <td>
                병원 주문 IT 서비스 운영
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <!-- <v-col
          cols="12"
          md="12"
          class="ui-col flex-cloumn"
        >
        <table class="pl-table">
          <colgroup>
            <col style="width:15%">
            <col style="width:15%">
            <col style="width:15%">
            <col style="width:10%">
            <col style="width:15%">
            <col style="width:15%">
            <col style="width:15%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col"><strong>수탁사명</strong></th>
              <th scope="col"><strong>목적<br>(위탁한 업무의 내용)</strong></th>
              <th scope="col"><strong>항목</strong></th>
              <th scope="col"><strong>이전국가</strong></th>
              <th scope="col"><strong>이전일시 및 이전 방법</strong></th>
              <th scope="col"><strong>보유이용기간</strong></th>
              <th scope="col"><strong>정보보호책임자 연락처</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Salesforce.com
              </td>
              <td>
                거래처 등록
              </td>
              <td>
                수집 및 이용에 동의한 항목
              </td>
              <td>
                싱가폴
              </td>
              <td>
                동의 시 혹은 필요 시 수시 이전
              </td>
              <td>
                거래처 계약에 준해 개인정보를 보관하는 기간
              </td>
              <td>
                +65-800-1301-448
              </td>
            </tr>
          </tbody>
        </table>
      </v-col> -->
      <v-col
          cols="12"
          md="12"
          class="ui-col flex-cloumn"
        >
          <p class="default-txt">② 회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
          <p class="default-txt">③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>
          <p class="default-txt"><span class="bold">제5조(정보주체의 권리·의무 및 행사방법)</span> ① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
          <p class="default-txt">1. 개인정보 열람요구<br>2. 오류 등이 있을 경우 정정 요구<br>3. 삭제요구<br>4. 처리정지 요구</p>
          <p class="default-txt">② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
          <p class="default-txt">③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
          <p class="default-txt">④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
          <p class="default-txt">⑤ 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</p>
          <p class="default-txt"><span class="bold">제6조(처리하는 개인정보 항목)</span> 회사는 제1조에 기재된 바와 같은 개인정보 항목을 처리하고 있습니다. 주민등록번호는 원천징수 등 법률·대통령령·국회규칙·대법원규칙·헌법재판소규칙 ·중앙선거관리위원회규칙 및 감사원규칙에서 구체적으로 주민등록번호의 처리를 요구하거나 허용한 경우에 한하여 처리합니다.</p>
          <p class="default-txt"><span class="bold">제7조(개인정보의 파기)</span> ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
          <p class="default-txt">② 정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
          <p class="default-txt">③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
          <p class="default-txt">1. 파기절차<br>회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.<br>2. 파기방법<br>회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 로우레밸포멧(Low Level Format) 등의 방법을 이용하여 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</p>
          <p class="default-txt"><span class="bold">제8조(개인정보의 안전성 확보조치)</span> 회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
          <p class="default-txt">1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등<br>2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치<br>3. 물리적 조치: 전산실, 자료보관실 등의 접근통제</p>
          <p class="default-txt"><span class="bold">제9조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)</span> ① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</p>
          <p class="default-txt">② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</p>
          <p class="default-txt">가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br>나. 쿠키의 설치∙운영 및 거부: 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.<br>다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>
          <p class="default-txt"><span class="bold">제10조(개인정보 보호책임자)</span> ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
          <p class="default-txt">▶ 개인정보 보호책임자<br>성명: 성종현<br>직책: 개인정보 보호책임자<br>전화번호: 02-2094-3361<br>이메일: JSung6@ITS.JNJ.com<br>주소: 서울시 용산구 한강대로 92 LS용산타워 26층 에이엠오아시아리미티드</p>
          <p class="default-txt">② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
          <p class="default-txt"><span class="bold">제11조(개인정보 열람청구)</span> 정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.</p>
          <p class="default-txt">▶ 개인정보 열람청구 접수·처리<br><a href="https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/83d8f093-3a5e-4953-88b0-5d5dd2d0c43f?ApplicationName=BeyondCataracts_Website" target="_blank"><u>신청서 작성 링크</u></a>를 클릭하시면, 개인정보 열람·삭제 청구서를 직접 작성하실 수 있습니다.<br>주소: 서울시 용산구 한강대로 92 LS용산타워 26층 에이엠오아시아리미티드</p>
          <p class="default-txt"><span class="bold">제12조(권익침해 구제방법)</span> 정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</p>
          <p class="default-txt">&#60;아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다&#62;</p>
          <p class="default-txt">▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)<br>- 소관업무: 개인정보 침해사실 신고, 상담 신청<br>- 홈페이지: <a href="https://privacy.kisa.or.kr/main.do" target="_blank"><u>https://privacy.kisa.or.kr/main.do</u></a><br>- 전화: (국번없이) 118<br>- 주소: (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터 </p>
          <p class="default-txt">▶ 개인정보 분쟁조정위원회<br>- 소관업무: 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)<br>- 홈페이지: <a href="https://www.kopico.go.kr/main/main.do" target="_blank"><u>https://www.kopico.go.kr/main/main.do</u></a><br>- 전화: (국번없이) 1833-6972<br>- 주소: (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층</p>
          <p class="default-txt">▶ 대검찰청 사이버범죄수사단: 02-3480-3573 <a href="https://www.spo.go.kr/site/spo/main.do" target="_blank"><u>(https://www.spo.go.kr/site/spo/main.do)</u></a></p>
          <p class="default-txt">▶ 경찰청 사이버안전국: 182 <a href="http://cyberbureau.police.go.kr" target="_blank"><u>(http://cyberbureau.police.go.kr)</u></a></p>
          <p class="default-txt"><span class="bold">제13조(영상정보처리기기 설치·운영)</span> ① 회사는 아래와 같이 영상정보처리기기를 설치·운영하고 있습니다.</p>
          <p class="default-txt">1. 영상정보처리기기 설치근거·목적: 회사의 시설안전 및 화재예방, 범죄 예방 및 수사</p>
          <p class="default-txt">2. 설치 대수, 설치 위치, 촬영 범위: 본사 26층에 7대 설치, 촬영범위는 로비 및 복도 등</p>
          <p class="default-txt">3. 관리책임자, 담당부서 및 영상정보에 대한 접근권한자: Facilities Management / 02-2094-3898</p>
          <p class="default-txt">4. 영상정보 촬영시간, 보관기간, 보관장소, 처리방법</p>
          <p class="default-txt">- 촬영시간: 24시간 촬영<br>- 보관기간: 촬영시부터 90일<br>- 보관장소 및 처리방법: Facilities Management Office에 보관하며 보관기간 만료 시 복원이 불가능한 방법으로 영구삭제처리</p>
          <p class="default-txt">5. 영상정보 확인 방법 및 장소: 관리책임자에 요구</p>
          <p class="default-txt">6. 정보주체의 영상정보 열람 등 요구에 대한 조치: 개인영상정보 열람·존재확인 청구서로 신청하여야 하며, 정보주체 자신이 촬영된 경우 또는 명백히 정보주체의 생명·신체·재산 이익을 위해 필요한 경우에 한해 열람을 허용함</p>
          <p class="default-txt">7. 영상정보 보호를 위한 기술적·관리적·물리적 조치: 내부관리계획 수립, 접근통제 및 접근권한 제한, 영상정보의 안전한 저장·전송기술 적용, 처리기록 보관 및 위·변조 방지조치, 보관시설 마련 및 잠금장치 설치 등</p>
          <p class="default-txt"><span class="bold">제14조(개인정보 처리방침 변경)</span> ① 이 개인정보 처리방침은 2023. 09. 23부터 적용됩니다.</p>
        </v-col>
    </v-row>
    <v-row>
    <v-col
          cols="12"
          md="12"
          class="ui-col flex-cloumn"
        >
          <p class="default-txt">
            이전의 개인정보처리방침은 아래 링크를 통해 확인하실 수 있습니다.
          </p>
          <p class="default-txt">
            <router-link to="/PersonalInformation" class="button default default-btn" style="color:blue;text-decoration:underline">
              개인정보처리방침 Ver. 1 (변경일 2019. 09. 02)  
            </router-link>
          </p>
        </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'OrderSearch',
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
  },
}
</script>